import { render, staticRenderFns } from "./SeniorList.vue?vue&type=template&id=240d57fc&scoped=true&"
import script from "./SeniorList.vue?vue&type=script&lang=js&"
export * from "./SeniorList.vue?vue&type=script&lang=js&"
import style0 from "./SeniorList.vue?vue&type=style&index=0&id=240d57fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d57fc",
  null
  
)

export default component.exports